<style scoped>
</style>

<template>
  <app-layout class="feed-single-page-template">
    <Row type="flex" justify="center" style="height: 100vh">
      <Col :span="24" style="text-align: center; top: 40vh;">
        <h1>
          Coming soon...
        </h1>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
export default {
  name: 'ContactUsSingleComponent',
  methods: {
    telNum(num) {
      return "tel:" + num
    }
  }
}
</script>
